<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Getting involved will enhance students’ leadership skills and forge
              beneficial long-term relationships
            </p>
          </div>
        </div>-->

        <div class="uk-padding uk-background-muted uk-margin-remove-top">

          <div class="uk-container uk-container-small ">
            <div class="uk-child-width-1-2@m" uk-grid>
              <div class="uk-text-center">
                <img src="../assets/usm.jpg" style="max-height: 300px; max-width: 300px; height: auto; width: auto;" alt="">

              </div>
              <div>
                <h3 class="uk-heading-bullet specHeading">United Student Movement</h3>
                <p class="">

                  The United Student Movement (USM) represents students’ interests on campus. Assisting in the
                  promotion of the ideals and objectives of the University, the USM co-ordinates a number of
                  activities and services. The organisation publishes a campus paper, The Hilltop Trumpet, as well
                  as a University yearbook, The Palm Leaves. It coordinates sporting activities on campus and
                  serves as an important link with the University administration, faculty, staff and students.
                  Students are voting members of the USM and are eligible to take advantage of the opportunities
                  the movement provides. A detailed description of the organization appears in its constitution
                  and bylaws.

                </p>

              </div>
            </div>

          </div>
        </div>

        <div class="uk-padding  uk-margin-remove-top">
          <h1 class="uk-heading-line uk-text-center specHeading"><span>Academic Clubs</span></h1>

          <div class="uk-container uk-container-small ">
            <div class="uk-child-width-1-1@m" uk-grid>
              <div class=" uk-text-muted">
                While the USM serves the needs of the general student body, other campus organisations relate
                to specific groups. The University encourages the formal association of students, recognizing
                that this fosters leadership and engenders the development of a wholesome sense of student
                fraternity.
                <br><br>
                Student associations and clubs operate under the sponsorship of faculty and staff members, but
                the officers are students. The following are some student organisations:

              </div>
              <div>
                <ul class="uk-list uk-list-divider uk-list-bullet ">
                  <li>
                    <span class="uk-text-bold">The Business and Secretarial Students Association (BASSO)</span> seeks to improve
                    scholarship, cultivate awareness regarding current economic trends and promotes high
                    standards of business ethics among its membership
                  </li>
                  <li>
                    <span class="uk-text-bold">The Northern Caribbean University Science Students Association (NCUSSA)</span>
                    aims at encouraging interest in and understanding of the ever-changing scientific world.
                  </li>
                  <li>
                    <span class="uk-text-bold">Humanities Behavioural and Social Sciences (HuBSS)</span> aims to cater to the needs of the
                    students of the College of Humanities Behavioural and Social Sciences to encourage
                    fellow students in their understanding of the academic system and their advancement
                    within this, their chosen profession, to promote an atmosphere conducive to
                    achievement and to promote camaraderie among HuBSS students and other campuses
                    and to create an avenue where students can demonstrate teaching and leadership skills.
                  </li>
                  <li>
                    <span class="uk-text-bold">College of Education and Leadership (CELS) </span> seeks to promote an avenue where
                    students can demonstrate teaching and leadership skills, inform students of
                    developments and topics of interest in the educational system and to promote the
                    interaction of students, faculty and stakeholders in the education profession.
                  </li>
                  <li>
                    <span class="uk-text-bold">Psychology Students’ Association (PSA) </span>
                    seeks to Expose students to different areas of
                    psychology, promote professional unification among students within the field of
                    psychology, create opportunities for students to exchange information, experiences and
                    resources and expose the NCU student body and community to the field of psychology
                    through outreach and volunteerism.
                  </li>
                  <li>
                    <span class="uk-text-bold">Geographical Society of Northern Caribbean University (GSONCU) </span>
                    aims to support and conduct non-partisan research, education and informational activities to increase public
                    awareness by empowering individuals to conserve and protect environmental resources
                    on a local, regional and international scale.
                  </li>
                  <li>
                    <span class="uk-text-bold">NCU Medical Technology Undergraduate Association (MUTUA)</span>
                    as a professional club
                    seeks to align itself with the Caribbean Association of Medical Technology, (CASMET)
                    and to foster interaction between its members and the public. Activities will
                    be conducted within the club to allow the members to bond and also be involved in a
                    variety of outreach activities.
                  </li>
                  <li>
                    <span class="uk-text-bold">The Ministerial Association (MA)</span>
                    emphasizes the development of religion majors but
                    opens its doors to all who desire spiritual fellowship. The Club, which seeks to elevate
                    among its members the high ideals of the gospel ministry, meets on Friday evenings
                    after the vesper service and in Sabbath Morning Prayer bands.
                  </li>
                  <li>
                    <span class="uk-text-bold">Association of Criminal Justice Students, (ACJuS)</span>
                    seeks to develop leadership skills and
                    teamwork among our peers. This will be achieved by encouraging interaction among
                    students and faculty of Northern Caribbean University along with professionals
                    employed in the field of Criminal Justice.
                  </li>
                  <li>
                    <span class="uk-text-bold">The Human Resource Management Association (HRMA)</span>
                    seeks to encourage fellow
                    students in their understanding of and their advancement within the Human Resource
                    Management profession, inform student members of current topics of interest in the
                    Human Resource Management profession and promote interaction between club
                    members and Human Resource Management professionals.
                  </li>
                  <li>
                    <span class="uk-text-bold">Northern Caribbean University Nutrition and Dietetics Students Association
                      (NCUNDSA)
                    </span>
                    seeks to cater to the needs of the Dietetics students of the College in the
                    Allied Health and Nursing, encourage fellow students in their understanding of the
                    Nutrition and Dietetics profession and promote health, well-being, and optimum
                    nutrition and promote the interaction of students, faculty and stakeholders in the
                    Nutrition and Dietetics professions
                  </li>
                  <li>
                    <span class="uk-text-bold">The Consortium of Communication, History, English, General Studies, Music, Art and
                      Pre-University (CCHEGMAP)
                    </span>
                    seeks to create an association which promotes leadership
                    skills, scholarships and fellowship in an environment which provides enrichment and
                    mental stimulation of the total experience of students from these areas.
                  </li>
                  <li>
                    <span class="uk-text-bold">The Computer Hardware Information Processing Specialists (CHIPS)
                    </span>
                    club exists to
                    promote the spirit of enquiry and dedication and to keep students in touch with the
                    frontiers of Computer Science, while supporting their creative interest and abilities in
                    technological skills
                  </li>
                  <li>
                    <span class="uk-text-bold">Society of Mathematics and Engineering (SOME)
                    </span>
                    is an academic club in the
                    Mathematics and Engineering Department. The primary aim of this club is to promote
                    interest in Mathematics and Engineering and to provide opportunities for interaction by
                    students who have an interest in these subjects.
                  </li>

                </ul>
              </div>
            </div>

          </div>
        </div>



      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "acasoclub",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Clubs',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Student Clubs at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h3{
      font-size: 1.2em !important;
    }
    h1{
      font-size: 1.2em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }
    img{
      width: 150px !important;
      height: 150px !important;
    }


  }
</style>
